import api from './api'
import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api'

export const authAPI = {
  login: async (credentials) => {
    return await api.post('/auth/login', credentials)
  },
  
  register: async (userData) => {
    return await api.post('/auth/register', userData)
  },
  
  getProfile: async () => {
    return await api.get('/auth/profile')
  },
  
  refreshToken: async () => {
    // Use raw axios (not the interceptor-wrapped api) to avoid infinite loops
    const response = await axios.post(
      `${API_BASE_URL}/auth/refresh`,
      {},
      { withCredentials: true }
    )
    return response.data
  },

  logout: async () => {
    return await api.post('/auth/logout')
  },
}
